export default {

	EVENT: {
		NOTIFICATION: {
			INFO: "NOTIFY_INFO",
			WARN: "NOTIFY_WARN",
			ERROR: "NOTIFY_ERROR",
			BANNER_INFO: "NOTIFY_BANNER_INFO",
			BANNER_CONF: "NOTIFY_BANNER_CONF",
			BANNER_ERROR: "NOTIFY_BANNER_ERROR",
			DEFAULT: "NOTIFY_DEFAULT",
		},
		MODAL: {
			GENERIC: "MODAL_WARN",
			CLOSE: "MODAL_CLOSE",
		},
		LOADER: {
			SHOW: "LOADER_SHOW",
			HIDE: "LOADER_HIDE",
		},
		GOOGLE: {
			FAST_ORDER: {
				GO_TO_PRODUCT: "GO_TO_PRODUCT",
				CHECK_AVAILABILITY: "CHECK_AVAILABILITY",
				BACK_IN_STOCK: "BACK_IN_STOCK",
				SIMILAR_PRODUCTS: "SIMILAR_PRODUCTS",
				ADD_TO_CART_FAST_ORDER: "ADD_TO_CART_FAST_ORDER"
			},
			ACCOUNT: {
				REPEAT_ORDER: "REPEAT_ORDER",
				REPEAT_ENTRY: "REPEAT_ENTRY",
			},
			PDP: {
				INIT: "INIT_PRODUCT",
				ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
				ADD_TO_CART_SUCCESS: "ADD_TO_CART_SUCCESS",
				ADD_TO_CART_ACCOUNT_SUCCESS: "ADD_TO_CART_ACCOUNT_SUCCESS",
				GO_TO_PRODUCT_FAST_ORDER: "GO_TO_PRODUCT",
				DOWNLOAD_HD_IMAGE: "DOWNLOAD_HD_IMAGE",
				DOWNLOAD_TECH_SHEET: "DOWNLOAD_TECH_SHEET",
				DOWNLOAD_INVOICE: "DOWNLOAD_INVOICE",
				DOWNLOAD_DDT: "DOWNLOAD_DDT",
				DOWNLOAD_DOCUMENT: "DOWNLOAD_DOCUMENT"
			},
			PLP: {
				INIT: "INIT_PLP",
				FROM_PLP_TO_PDP: "TO_PDP",
				TO_PLP: "TO_PLP"
			},
			CART: {
				REMOVE_QUANTITY: "REMOVE_QUANTITY",
				INCREASE_QUANTITY: "INCREASE_QUANTITY",
				MODIFIED_QUANTITY: "MODIFIED_QUANTITY",
				REMOVE: "REMOVE",
				MODIFIED_CAUSALITY: "MODIFIED_CAUSALITY",
				VIEW: "VIEW"
			},
			CHECKOUT: {
				STEP1: "DELIVERY_ADDRESS",
				STEP2: "DELIVERY_METHOD",
				STEP3: "PAYMENT_METHOD",
				STEP4: "SUMMARY_PAGE",
				STEP5: "PURCHASE",
				ONLY_ONE_STEP: "ONLY_ONE_STEP"
			},
			ORDER_CONFIRMATION: "ORDER_CONFIRMATION",
			SELECT_AREA: "SELECT_AREA",
			ORDER_CONFIRMATION_FROM_SINGLE_STEP: "ORDER_CONFIRMATION_FROM_SINGLE_STEP",
			ORDER_TOTALS: "ORDER_TOTALS",
			LOG_IN: "LOG_IN",
			NEWSLETTER: "NEWSLETTER",
			ERROR: "ERROR",
			SELECT_CONTENT: "SELECT_CONTENT",
		},
	},
	HTTP: {
		RESPONSE: {
			OK: "OK",
			KO: "KO",
		}
	},
	DIVISION: {
		COMMERCIAL_ORGANIZATION: {
			'flagInteriors': {
				'00001': "00015"
			}
		},
		FLAGS: {
			SHOWROOM: ["flagShowRoom", "flagShowRoom4", "flagShowRoom5"],
			FLAGINTERIORS: "flagInteriors"
		}
	},
	PRODUCT: {
		IMAGE: {
			FORMATS: {
				PRODUCT: 'product'
			}
		},
	},
	CLASSIFICATION: {
		'00015': {
			HEIGHT: 'altfinmin15',
			MIN_HEIGHT: 'altfinmin',
			WEIGHT: 'persfinmax15',
			MEASURE: 'nr',
		}
	}

}



// WEBPACK FOOTER //
// ./src/utils/Constants.js